export const isObjectType = (value) => typeof value === 'object';
